import { useState } from 'react';
import ModalConfirmAanmelden from './ModalConfirmAanmelden';
import { formatDateLong } from '../../helperfunctions/helperfunctions';
import { IoCheckmarkDoneSharp } from 'react-icons/io5';
import { useAuth } from '../../utils/auth';
import { handleData } from '../../api';

const TaakAanmeldBox = (props) => {

    const auth = useAuth();

    const { activiteit, taak, includeUpdate } = props;
    const activiteitID = activiteit._id;
    const activiteitNaam = activiteit.naam;
    const activiteitDatum = formatDateLong(activiteit.datum);
    const taakID = taak._id;
    const { vrijwilliger, bevestigd, taaknaam } = taak;
    const gebruikersnaam = vrijwilliger ? vrijwilliger.gebruikersnaam : "";

    const [ confirmPopup, setConfirmPopup ] = useState(false);

    const handleClickAanmelden = () => {
        setConfirmPopup(true);
    }

    const cancelAanmelden = () => {
        setConfirmPopup(false);
    }

    const confirmAanmelden = async(extraInfo) => {
        const path = `activiteiten/${activiteitID}/taken/${taakID}`;
        const patchData = {
            method: 'PATCH',
            path: path,
            input: {
                'taken.$.vrijwilliger': auth.user._id,
                'taken.$.bevestigd': false,
                'taken.$.vrijwilligerOpmerking': extraInfo
            }
        }
        const result = await handleData(patchData);
        includeUpdate(result.data.data);

        setConfirmPopup(false);

    }

    return (
        <div className="taakAanmeldBox">
            <div className="aangemeldeVrijwilliger">
                {vrijwilliger &&
                    <div className="bevestiging">
                        {bevestigd && <div className='iconConfirmed'><IoCheckmarkDoneSharp /></div> }
                        {bevestigd ? <p>Ingedeeld: </p> : <p>Aangemeld: </p>}
                        <p>{gebruikersnaam}</p>
                    </div>
                }
                {!vrijwilliger && <button className='aanmelden button' onClick={handleClickAanmelden}> Meld je aan als vrijwilliger</button>}
            </div>
            {confirmPopup && 
                <div>
                    <ModalConfirmAanmelden 
                        activiteitNaam={activiteitNaam}
                        activiteitDatum={activiteitDatum}
                        taaknaam={taaknaam}
                        cancelAanmelden={cancelAanmelden}
                        confirmAanmelden={confirmAanmelden}

                    />             
                </div>
            }
        </div>
    );
}

export default TaakAanmeldBox;